      
      
import { capitalizeEveryWord } from 'helpers'
import { useMemo, useState } from 'react'
import { Check, ChevronDown, X } from 'react-feather'
import { Input } from 'reactstrap'
import {
  DEFAULT_FILTERS,
  LOKASI_OPTIONS,
  LUAS_OPTIONS,
  filterOptions,
  isDefaultFilters,
} from './memberFilters'

export default function FilterChips({ farmerList, filters, onChange }) {
  const [open, setOpen] = useState('')
  const [query, setQuery] = useState('')
  const { items, lands } = useMemo(
    () => filterOptions(farmerList),
    [farmerList],
  )

  const set = (key, value) => onChange({ ...filters, [key]: value })
  const toggleIn = (key, value) =>
    set(
      key,
      filters[key].includes(value)
        ? filters[key].filter((v) => v !== value)
        : [...filters[key], value],
    )

  const chip = (key, label, activeLabel, menu) => (
    <div className="gm-chip-wrap" key={key}>
      <button
        type="button"
        className={`gm-chip ${activeLabel ? 'gm-chip--active' : ''}`}
        onClick={() => {
          setOpen(open === key ? '' : key)
          setQuery('')
        }}
        aria-expanded={open === key}
        aria-haspopup="menu"
      >
        {activeLabel || label}
        <ChevronDown size={14} />
      </button>
      {open === key ? (
        <>
          <div className="gm-menu-backdrop" onClick={() => setOpen('')} />
          <div className="gm-menu gm-menu--filter" role="menu">
            {menu}
          </div>
        </>
      ) : null}
    </div>
  )

  const singleMenu = (key, options) =>
    options.map((o) => (
      <button
        type="button"
        role="menuitemradio"
        aria-checked={filters[key] === o.value}
        key={o.value}
        className={`gm-menu-item ${
          filters[key] === o.value ? 'gm-menu-item--active' : ''
        }`}
        onClick={() => {
          set(key, filters[key] === o.value ? '' : o.value)
          setOpen('')
        }}
      >
        <span className="gm-menu-check">
          {filters[key] === o.value ? <Check size={16} /> : null}
        </span>
        <span className="gm-menu-title">{o.label}</span>
      </button>
    ))

  const multiMenu = (key, values, format = (v) => v) => {
    const q = query.trim().toLowerCase()
    const shown = q
      ? values.filter((v) => String(format(v)).toLowerCase().includes(q))
      : values
    return (
      <>
        {values.length > 6 ? (
          <div className="gm-menu-search">
            <Input
              type="text"
              bsSize="sm"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Cari..."
              aria-label="Cari pilihan filter"
              autoFocus
            />
          </div>
        ) : null}
        {shown.length ? (
          shown.map((v) => (
            <label key={v} className="gm-menu-item gm-menu-item--check">
              <input
                type="checkbox"
                className="form-check-input m-0"
                checked={filters[key].includes(v)}
                onChange={() => toggleIn(key, v)}
              />
              <span className="gm-menu-title">{format(v)}</span>
            </label>
          ))
        ) : (
          <div className="p-2 gm-muted">Tidak ada yang cocok.</div>
        )}
        {filters[key].length ? (
          <button
            type="button"
            className="gm-menu-clear"
            onClick={() => set(key, [])}
          >
            Hapus pilihan ({filters[key].length})
          </button>
        ) : null}
      </>
    )
  }

  const optionLabel = (options, value) =>
    options.find((o) => o.value === value)?.label

  return (
    <>
      {chip(
        'lokasi',
        'Lokasi lahan',
        optionLabel(LOKASI_OPTIONS, filters.lokasi),
        singleMenu('lokasi', LOKASI_OPTIONS),
      )}
      {items.length
        ? chip(
            'barang',
            'Barang',
            filters.barang.length === 1
              ? filters.barang[0]
              : filters.barang.length
                ? `Barang (${filters.barang.length})`
                : '',
            multiMenu('barang', items),
          )
        : null}
      {chip(
        'luas',
        'Luas lahan',
        optionLabel(LUAS_OPTIONS, filters.luas),
        singleMenu('luas', LUAS_OPTIONS),
      )}
      {lands.length
        ? chip(
            'lahan',
            'Jenis lahan',
            filters.lahan.length ? `Jenis lahan (${filters.lahan.length})` : '',
            multiMenu('lahan', lands, capitalizeEveryWord),
          )
        : null}
      {!isDefaultFilters(filters) ? (
        <button
          type="button"
          className="gm-chip"
          onClick={() => onChange(DEFAULT_FILTERS)}
        >
          <X size={14} />
          Reset
        </button>
      ) : null}
    </>
  )
}

    

    